import { render, staticRenderFns } from "./TableData.vue?vue&type=template&id=dc365180&scoped=true"
import script from "./TableData.vue?vue&type=script&lang=ts"
export * from "./TableData.vue?vue&type=script&lang=ts"
import style0 from "./TableData.vue?vue&type=style&index=0&id=dc365180&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc365180",
  null
  
)

export default component.exports